"use strict";

module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/__/index.js
// module id = 518
// module chunks = 0